<template>

    <section class="dd-l-section--video">

        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-container__wrapper dd-l-container__wrapper--grid dd-l-container__wrapper--full"
             v-if="data.length">
            <Slick ref="slick" :options="slickOptions" class="dd-m-carousel dd-m-carousel-videos">
                <div class="dd-l-section--video__container" v-for="(item, index) in data">
                    <h2 class="dd-l-section--video__title" v-html="item.title"></h2>

                    <card-video :show="show"
                                :item="item"></card-video>
                </div>
            </Slick>
        </div>

        <modal-video></modal-video>
    </section>

</template>
<script>
    import axios from 'axios';
    import Slick from "vue-slick";
    import SlickOptions from "../../providers/slick";
    import Loading from "../loading";
    import CardVideo from "../cards/card-video";
    import ModalVideo from "../modals/video";

    const slickOptions = new SlickOptions();

    export default {
        name: 'banner-video-home',
        components: {ModalVideo, CardVideo, Loading, Slick},
        data: () => {
            return {
                data: [],
                isLoading: false,
                slickOptions: slickOptions.getDefault(true, false),
            }
        },
        mounted() {
            this.isLoading = true;
            axios.get(`/api/banner/3?language=${language}&perPage=3`)
                .then((res) => {
                    const data = res.data.data;
                    this.data = data;
                    this.isLoading = false;
                })
                .catch(() => this.isLoading = false);
        },
        methods: {
            show(video) {
                PubSub.publish('video-open', video);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-video-home.vue